"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDownIcon, LoaderIcon } from "lucide-react";
import Markdown from "./markdown";
export function MessageReasoning(t0) {
  const $ = _c(12);
  const {
    isLoading,
    reasoning
  } = t0;
  const [isExpanded, setIsExpanded] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      collapsed: {
        height: 0,
        opacity: 0,
        marginTop: 0,
        marginBottom: 0
      },
      expanded: {
        height: "auto",
        opacity: 1,
        marginTop: "1rem",
        marginBottom: "0.5rem"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const variants = t1;
  let t2;
  if ($[1] !== isExpanded || $[2] !== isLoading) {
    t2 = isLoading ? <div className="flex flex-row gap-2 items-center"><div className="font-medium">Reasoning</div><div className="animate-spin"><LoaderIcon /></div></div> : <div className="flex flex-row gap-2 items-center"><div className="font-medium">Reasoned for a few seconds</div><button data-testid="message-reasoning-toggle" type="button" className="cursor-pointer" onClick={() => {
        setIsExpanded(!isExpanded);
      }}><ChevronDownIcon /></button></div>;
    $[1] = isExpanded;
    $[2] = isLoading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isExpanded || $[5] !== reasoning) {
    t3 = isExpanded && <motion.div data-testid="message-reasoning" key="content" initial="collapsed" animate="expanded" exit="collapsed" variants={variants} transition={{
      duration: 0.2,
      ease: "easeInOut"
    }} style={{
      overflow: "hidden"
    }} className="pl-4 text-zinc-600 dark:text-zinc-400 border-l flex flex-col gap-4"><Markdown>{reasoning}</Markdown></motion.div>;
    $[4] = isExpanded;
    $[5] = reasoning;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <AnimatePresence initial={false}>{t3}</AnimatePresence>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex flex-col">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}